import styled from '@themes/theme'

export const VocPageWrap = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  background: #bdcff8;
  .title-wrap.no-bg {
    width: 100%;
    svg path {
      fill: #000;
    }
  }
  .voc-top-img {
    z-index: 1;
    position: relative;
    top: -24px;
    width: 315px;
    height: 156px;
  }
  .voc-contents {
    position: relative;
    top: -33px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    width: 330px;
    margin: 0 auto -16px;
    padding: 15px 17px 24px;
    background: #fff;
    border-radius: 14px;
    .voc-img-01 {
      width: auto;
      height: 226px;
    }
    .voc-img-02 {
      width: auto;
      height: 85px;
      margin-left: 15px;
    }
    .voc-img-03 {
      width: auto;
      height: 72px;
    }
    .voc-page-survey {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      flex-wrap: wrap;
      flex: 1;
      margin: 14px 0 11px 0;
      &--txt {
        width: 100%;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        flex-wrap: wrap;
        text-align: center;
        span {
        margin-right: 21px;
          margin-bottom: 14px;
          line-height: 22px;
          font-size: ${props=>props.theme.font.title};
          color: #363739;
        }
      }
      .voc-page-textarea {
        flex: 1;
        width: 100%;
        height: 305px;
        padding: 10px 15px;
        line-height: 2.1rem;
        color: #363739;
        font-size: ${props=>props.theme.font.title};
        border-radius: 10px;
        border: 2px solid #c4d4f8;
        resize: none;
        &::placeholder {
          color: #d2d4d2 !important;
          opacity: 1; /* Firefox */
        }
      }
    }
    .voc-page-check-box-tit {
      margin: 0 auto;
      line-height: 1.8rem;
      text-align: center;
      color: #688de4;
      font-size: ${props=>props.theme.font.large};
      .voc-point-color {
        color: #3969d9;
        font-size: ${props=>props.theme.font.large};
      }
    }
    .voc-page-check-box {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 80%;
      margin: 16px 0 14px;
      text-align: center;
      label {
        width: auto;
        input {
          position: absolute;
          left: 0;
          width: 1px;
          height: 1px;
          margin: -1px;
          padding: 0;
          overflow: hidden;
          border: 0;
          clip: rect(0, 0, 0, 0);
          & ~ .check.img {
            position: relative;
            top: -1px;
            width: 15px;
            margin-right: 5px;
            &.on {
              display: none;
            }
          }
          &:checked ~ .check.img {
            &.on {
              display: inline-block;
            }
            &.off {
              display: none;
            }
          }
        }
      }
      .check-box-txt {
        color: #3969d9;
        font-size: ${props=>props.theme.font.large};
      }
    }
    .voc-page-btn {
      margin-top: 12px;
      width: 240px;
      height: 40px;
      font-size: 22px;
      color: #fff;
      background: #858585;
      &.active {
        background: #5e87e5;
      }
    }
  }
`
